<template>
	<div>
		<slot
			:checked-items="checkedItems"
			:is-checked="isChecked"
			:toggle-checkbox="toggleCheckbox"
		></slot>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
	storageKey: {
		type: String,
		required: true
	}
})

const checkedItems = ref([])

const loadFromStorage = () => {
	try {
		const stored = localStorage.getItem(props.storageKey)
		if (stored) {
			checkedItems.value = JSON.parse(stored)
		}
	} catch (e) {
		console.error('Error loading from localStorage:', e)
	}
}

const saveToStorage = () => {
	try {
		localStorage.setItem(props.storageKey, JSON.stringify(checkedItems.value))
	} catch (e) {
		console.error('Error saving to localStorage:', e)
	}
}

const toggleCheckbox = (value) => {
	const index = checkedItems.value.indexOf(value)
	if (index > -1) {
		checkedItems.value.splice(index, 1)
	} else {
		checkedItems.value.push(value)
	}
	saveToStorage()
}

const isChecked = (value) => {
	return checkedItems.value.includes(value)
}

onMounted(() => {
	loadFromStorage()
})
</script>
